<template>
  <div>
    <v-card
      flat
      min-height="90vh"
      class="d-flex align-center justify-center"
      style="z-index: 1;">
      <v-card-text style="width: 400px;">
        <div
          class="text-h5 text-center font-weight-bold mb-2"
          :style="`color: #4828a1;`">
          Loading
        </div>

        <!-- <div
          class="body-1 text-center">
          Tiket Pariwisata Disbudporapar
        </div> -->

        <div
          class="body-1 text-center mt-2">
          Mohon untuk tunggu sebentar
        </div>

        <div
          class="d-flex justify-center ma-6">
          <v-progress-linear
            indeterminate
            height="8"
            rounded
            class="loader"
            :color="set_color">
          </v-progress-linear>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>

import { TokenService } from "@/service/Storage.Service";
  export default {
    computed: {
      // set_color () {
      //   return this.$store.state.header.config.color
      // }
    },
    mounted () {
      TokenService.removeToken()
              
      window.location = '/login'
    }
  }
</script>